import api from "./api";

export interface PendingSettlement {
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
    branchId?: string;
  };
  salesCount: number;
  salesAmount: number;
  rechargesCount: number;
  rechargesAmount: number;
  transactionsCount: number;
  transactionsAmount: number;
  cashSalesAmount: number;
  cashRechargesAmount: number;
  amountToCollect: number;
  totalAmount: number;
  hasPending: boolean;
  recentSales?: unknown[];
  recentRecharges?: unknown[];
  recentTransactions?: unknown[];
}

export const settlementAPI = {
  async getPending(userId: string): Promise<PendingSettlement> {
    const response = await api.get(`/settlements/pending/${userId}`);
    return response.data.data;
  },

  async settle(userId: string, notes?: string): Promise<unknown> {
    const response = await api.post("/settlements", { userId, notes });
    return response.data.data;
  },

  async getHistory(
    userId: string,
    pageNo = 1,
    pageSize = 10
  ): Promise<{ data: unknown[]; total: number }> {
    const response = await api.get(`/settlements/history/${userId}`, {
      params: { pageNo, pageSize },
    });
    const payload = response.data.data;
    return {
      data: payload?.items ?? [],
      total: payload?.totalRecords ?? 0,
    };
  },
};

export default settlementAPI;
